const SESSION_IDLE_TIMEOUT_MS = 4 * 60 * 60 * 1000;

export const SESSION_LAST_ACTIVITY_KEY = "irriwatch:lastActivityAt";

export const getLastSessionActivity = (): number | undefined => {
    const value = localStorage.getItem(SESSION_LAST_ACTIVITY_KEY);

    if (value === null) {
        return undefined;
    }

    const timestamp = Number(value);

    return Number.isFinite(timestamp) ? timestamp : undefined;
};

export const recordSessionActivity = (timestamp = Date.now()): void => {
    localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, timestamp.toString());
};

export const clearSessionActivity = (): void => {
    localStorage.removeItem(SESSION_LAST_ACTIVITY_KEY);
};

export const isSessionIdleExpired = (now = Date.now()): boolean => {
    const lastActivity = getLastSessionActivity();

    return lastActivity !== undefined && now - lastActivity >= SESSION_IDLE_TIMEOUT_MS;
};
